import React, { createContext } from "react";

import ButtonHelp from "../../ui/ButtonHelp";

import { useParams } from "react-router-dom";
import FederalContract from "./FederalContract";
import SLEDContract from "./SledContract";
import GrantContract from "./GrantContract";
import SbirContract from "./SbirContract";

// Create a context for isLoading
export const ContractContext = createContext();

export const steps = [
  {
    target: "#contract-save-button",
    content: "Add to saved opportunity",
    title: "Save Opportunity",
    placement: "bottom-end",
    disableBeacon: true,
  },
  {
    target: "#contract-view-button",
    content: "View the contract on Sam.gov",
    title: "View Contract",
    placement: "bottom-end",
    disableBeacon: true,
  },
  {
    target: "#contract-generate-button",
    content: "Start generating proposal",
    title: "Generate Proposal",
    placement: "bottom-end",
    disableBeacon: true,
  },
  {
    target: "#contract-chat-button",
    content: "Start a chat with AI",
    title: "Chat With AI",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    target: "#contract-summary",
    content: "AI-powered summary of the contract's details",
    title: "Smart Summary",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    target: "#contract-details",
    content: "Find all key contract details listed here",
    title: "Contract Info",
    placement: "top-end",
    disableBeacon: true,
  },
  {
    target: "#contract-description",
    content: "Original contract description",
    title: "Contract Description",
    placement: "bottom-start",
    disableBeacon: true,
  },
  {
    target: "#contract-attachments",
    content:
      "View the opportunity's attachments and links. Click the wand for AI summary or download the document",
    title: "Contract Attachments",
    placement: "top-end",
    disableBeacon: true,
  },
  {
    target: "#contract-recommendations",
    content:
      "Explore similar opportunities and top contractors in this industry",
    title: "Recommended",
    placement: "top-center",
    disableBeacon: true,
  },
];

function GetContract({ contract }) {
  // Extract type and proposal_id from the URL
  const { searchType } = useParams();
  switch (searchType) {
    case "federal":
      return <FederalContract contract={contract} />;
    case "sled":
      return <SLEDContract contract={contract} />;
    case "grant":
      return <GrantContract contract={contract} />;
    case "sbir":
      return <SbirContract contract={contract} />;
    default:
      return <FederalContract contract={contract} />;
  }
}
function ContractDescription({ contract, isLoading }) {
  return (
    <ContractContext.Provider value={{ isLoading }}>
      <GetContract contract={contract} isLoading={isLoading} />
      <ButtonHelp steps={steps} />
    </ContractContext.Provider>
  );
}

export default ContractDescription;
